import { useState, type ReactNode } from "react";
import { NumberField } from "@/components/ui/FormControls";

/**
 * 숫자 입력 , 스토어의 number | null 과 입력칸의 문자열을 잇는다.
 * 지우는 동안에는 임시 문자열을 들고 있다가(빈 칸이 100 으로 되돌아가지 않게), 초점이 나가면 스토어 값으로 맞춘다.
 * allowNull 이 false 면 빈 칸은 스토어에 쓰지 않는다(필수 양수값).
 */
export function NumField({
  label, unit, value, onChange, allowNull = true, hint, error, disabled, min, step, placeholder, id,
}: {
  label: ReactNode;
  unit: ReactNode;
  value: number | null | undefined;
  onChange: (v: number | null) => void;
  allowNull?: boolean;
  hint?: ReactNode;
  error?: ReactNode;
  disabled?: boolean;
  min?: number;
  step?: number | "any";
  placeholder?: string;
  id?: string;
}) {
  const [draft, setDraft] = useState<string | null>(null);
  // 편집 중이 아닐 때는 부동소수점 꼬리(246.26871875)를 잘라 보인다 , 스토어 값은 그대로다
  const shown = draft ?? (value === null || value === undefined ? "" : String(Math.round(value * 1e6) / 1e6));
  return (
    <NumberField
      id={id}
      label={label}
      unit={unit}
      hint={hint}
      error={error}
      disabled={disabled}
      min={min}
      step={step ?? "any"}
      placeholder={placeholder}
      value={shown}
      onChange={(e) => {
        const t = e.target.value;
        setDraft(t);
        if (t === "") {
          if (allowNull) onChange(null);
          return;
        }
        const n = Number(t);
        if (Number.isFinite(n)) onChange(n);
      }}
      onBlur={() => setDraft(null)}
    />
  );
}
